module.exports = __webpack_public_path__ + "202408221624/img/help_sence.85b86338.jpg";